import { notificationSlice } from '@/store/notification/notification.slice'
import { AnyAction, combineReducers, configureStore } from '@reduxjs/toolkit'
import { userSlice } from './user/user.slice'
import { flowsheetSlice } from './flowsheet/flowsheet.slice'
import { projectSlice } from './project/project.slice'

export const allReducers = {
  user: userSlice.reducer,
  notification: notificationSlice.reducer,
  flowsheet: flowsheetSlice.reducer,
  project: projectSlice.reducer,
}

export function logoutAction() {
  return {
    type: 'LOGOUT'
  }
}

const combinedReducer = combineReducers(allReducers)

const rootReducer = (state, action: AnyAction) => {
  if (action.type === 'LOGOUT') {
    return combinedReducer({} as any, action)
  }

  return combinedReducer(state, action)
}

export const store = configureStore({
  reducer: rootReducer
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
